import React, { useEffect, useMemo, useState, useCallback } from "react";
import "./CategoryContainer.css";
import moment from "moment";
import "moment/dist/locale/ru";

const CategoryContainer = (props) => {
    const [open, setOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(null);
    const [newPrice, setNewPrice] = useState({ price: 0 });
    const handleDoubleClick = useCallback(
        (date, id, price, roomTypeId, fieldId) => {
            price =
                fieldId === 0
                    ? +price?.[0]
                        ? +price?.[0]
                        : 0
                    : price
                      ? +price
                      : 0;
            setNewPrice({ price, date, roomTypeId, fieldId });
            setIsEditing({ date, id });
        },
        [],
    );

    const handleChange = useCallback((e) => {
        const value = +e.target.value;

        //Если ввели не цифру, игнорируем
        if (isNaN(value)) {
            return;
        }

        setNewPrice((prevState) => ({
            ...prevState,
            price: value,
        }));
    }, []);

    const handleKeyDown = useCallback(
        (e) => {
            if (e.key === "Enter") {
                setIsEditing(null);
                props.savePrice(newPrice);
            }
        },
        [newPrice],
    );

    const handleBlur = useCallback(() => {
        setIsEditing(null);
        props.savePrice(newPrice);
    }, [newPrice]);

    const handleOpen = useCallback(() => {
        setOpen((pr) => !pr);
        props.handleCloseAllMultiSelects();
    }, [props]);

    const monthsMemo = useMemo(() => {
        return props.months?.map((m, idx) =>
            props
                .generateMonthDates(
                    props.startDate,
                    props.endDate,
                    m,
                    idx,
                    true,
                    props.prices,
                    props.roomType.id,
                )
                .map((d, index) => {
                    const includesDates = props.selectedDates.includes(d.date);
                    const date = moment(d.date, "DD.MM.YY");

                    const formattedDate = date.format("D MMM").replace(".", "");
                    const dayOfWeek = date.format("ddd").toUpperCase();

                    const cellClass =
                        (idx === 0 &&
                            {
                                close: " cell-closed",
                                empty: " cell-empty",
                                null: " cell-null",
                                negative: " cell-negative",
                            }[d.quotaStatus]) ||
                        "";

                    return d === "title_row" ? (
                        <div
                            key={"first-element" + index}
                            className="first-element"
                        >
                            {props.selectedFields.map((q, q_num) => {
                                if (
                                    props.roomType.count_main_seat >= q_num ||
                                    q_num >= 13
                                )
                                    return (
                                        <div
                                            key={q.id + "_quotas-element"}
                                            className={
                                                "quotas-element" +
                                                (q_num ===
                                                props.selectedFields.length - 1
                                                    ? " border-none"
                                                    : "")
                                            }
                                        >
                                            {q.name}
                                        </div>
                                    );
                            })}
                        </div>
                    ) : d === "empty" ? (
                        <div key={"empty-element" + index}></div>
                    ) : (
                        <div
                            key={"category_" + d.date}
                            data-id={d.date + "^" + props.roomType.id}
                            className={
                                "category-date" +
                                " category-date_" +
                                props.roomType.id +
                                (includesDates ? " striped" : "")
                            }
                        >
                            <div className="title-date__price">
                                <div>{formattedDate}</div>
                                <div>{dayOfWeek}</div>
                            </div>
                            <div
                                className={
                                    "data-date__price" +
                                    ([0, 6].includes(
                                        moment(d.date, "DD.MM.YY").day(),
                                    )
                                        ? " week-end"
                                        : "")
                                }
                            >
                                {props.selectedFields.map((f, f_num) => {
                                    //Если ид поля = 0, то это поле квот, со своим форматированием
                                    const priceCell =
                                        f.id === 0
                                            ? (d.price?.[f.id]?.[0] ?? "-") +
                                              " | " +
                                              (d.price?.[f.id]?.[1] ?? "-")
                                            : d.price?.[f.id];
                                    if (
                                        props.roomType.count_main_seat >=
                                            f_num ||
                                        f_num >= 13
                                    )
                                        return (
                                            <div
                                                key={f.name}
                                                onDoubleClick={() =>
                                                    handleDoubleClick(
                                                        d.date,
                                                        f.id,
                                                        d.price?.[f.id],
                                                        props.roomType.id,
                                                        f.id,
                                                    )
                                                }
                                                className={
                                                    "date-price" +
                                                    (f.id ===
                                                    props.selectedFields
                                                        ?.length -
                                                        1
                                                        ? " border-none"
                                                        : "") +
                                                    (f.id !== 0 &&
                                                    d.priceStatus === "close"
                                                        ? " cell-closed"
                                                        : "") +
                                                    (f.id === 0 &&
                                                    d.quotaStatus === "close"
                                                        ? " cell-closed"
                                                        : f.id === 0 &&
                                                            d.quotaStatus ===
                                                                "empty"
                                                          ? " cell-empty"
                                                          : f.id === 0 &&
                                                              d.quotaStatus ===
                                                                  "null"
                                                            ? " cell-null"
                                                            : f.id === 0 &&
                                                                d.quotaStatus ===
                                                                    "negative"
                                                              ? " cell-negative"
                                                              : "")
                                                }
                                            >
                                                {isEditing &&
                                                isEditing.date === d.date &&
                                                isEditing.id === f.id ? (
                                                    <input
                                                        type="text"
                                                        value={newPrice.price}
                                                        onChange={handleChange}
                                                        onKeyDown={
                                                            handleKeyDown
                                                        }
                                                        onBlur={handleBlur}
                                                        autoFocus
                                                        className="new-price-input"
                                                    />
                                                ) : (
                                                    formatNumberWithSpaces(
                                                        priceCell,
                                                        f.id,
                                                    )
                                                )}
                                            </div>
                                        );
                                })}
                            </div>
                        </div>
                    );
                }),
        );
    }, [
        props.prices,
        props.months,
        props.selectedDates,
        props.selectedFields,
        isEditing,
        handleDoubleClick,
        handleChange,
        handleKeyDown,
        handleBlur,
    ]);

    return (
        <div
            className="main-category"
            onClick={() => props.handleCloseAllMultiSelects()}
        >
            <div className="category-name" onClick={handleOpen}>
                <span>{props.roomType.name}</span>
                <span>{open ? arrowOpen : arrowClose}</span>
            </div>
            {open && <div className="category-dates">{monthsMemo}</div>}
        </div>
    );
};

export default CategoryContainer;

const formatNumberWithSpaces = (number, idx) => {
    if (idx === 0) {
        return number ?? "-";
    }

    return number
        ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        : "-";
};

const arrowClose = (
    <svg
        width="8"
        height="4"
        viewBox="0 0 8 4"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.38181 0H3.82198H0.616412C0.0678664 0 -0.206406 0.607131 0.182147 0.963036L3.14201 3.67419C3.61627 4.1086 4.38767 4.1086 4.86193 3.67419L5.98759 2.64311L7.82179 0.963036C8.20463 0.607131 7.93036 0 7.38181 0Z"
            fill="#1F1F1F"
        />
    </svg>
);

const arrowOpen = (
    <svg
        width="8"
        height="4"
        viewBox="0 0 8 4"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.38181 4H3.82198H0.616412C0.0678664 4 -0.206406 3.39287 0.182147 3.03696L3.14201 0.32581C3.61627 -0.108603 4.38767 -0.108603 4.86193 0.32581L5.98759 1.35689L7.82179 3.03696C8.20463 3.39287 7.93036 4 7.38181 4Z"
            fill="#9F9F9F"
        />
    </svg>
);
